import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core"
import { UserService } from "../../services/user.service"
import { Params, QueryParamsHandling, Router } from "@angular/router"

@Component({
    selector: "app-link",
    templateUrl: "./link.component.html",
    styleUrls: ["link.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class LinkComponent implements OnInit {
    @Input() href = null
    @Input() appRouterLink: any[] | string | null | undefined = null
    @Input() tabIndex: number
    @Input() queryParams: Params
    @Input() routerLinkActive: string[] | string = ""
    @Input() queryParamsHandling: QueryParamsHandling = null
    @Input() title: string = ""
    @Input() target: string = ""
    @Input() badgeCount: number = 0
    @Input() isChildRouteCustomFN: Function = () => {
        return this.router.url.includes(this.appRouterLink as string)
    }
    /**
     * Emitted from the anchor itself (not the app-link host), so consumers
     * don't depend on the click bubbling up through the component boundary.
     */
    @Output() primaryClick = new EventEmitter<MouseEvent>()
    @Output() middleClick = new EventEmitter<MouseEvent>()

    constructor(
        private userService: UserService,
        private router: Router
    ) {}

    public ngOnInit() {
        this.setStudentInQueryParam()
        this.checkRequiredInputs()
    }

    // Sets student=true in query params for appRouterLink and href inputs
    private setStudentInQueryParam(): void {
        const { student } = this.userService.getStudentQueryParams()
        if (!student) return

        if (this.appRouterLink && this.appRouterLink != "/student") {
            this.queryParams = {
                ...this.queryParams,
                student,
            }
            return
        }

        if (this.href) {
            this.href += this.href.includes("?") ? "&student=true" : "?student=true"
        }
    }

    get isChildRoute(): boolean {
        return this.isChildRouteCustomFN()
    }

    /**
     * A native "click" is expected to always carry button 0 (primary button
     * or keyboard activation), but some mice/trackpad drivers or assistive
     * tools can synthesize one with a different button — filter explicitly
     * so `primaryClick` is never a stand-in for a different physical button.
     */
    public onClick(event: MouseEvent): void {
        if (event.button !== 0) return
        this.primaryClick.emit(event)
    }

    /**
     * Middle-click (open in new tab) fires "auxclick", not "click" — filter
     * here so consumers can treat `middleClick` as a real middle-click signal.
     */
    public onAuxClick(event: MouseEvent): void {
        if (event.button !== 1) return
        this.middleClick.emit(event)
    }

    private checkRequiredInputs(): void {
        if (!this.href && !this.appRouterLink) {
            throw new Error("Attribute 'href' or 'appRouterLink' is required")
        }
    }
}
